var render = function render(){var _vm=this,_c=_vm._self._c;return _c('memlist-card',{staticClass:"login-body mb-5 mt-8"},[_c('h1',[_vm._v("Kontakta Memlist Support")]),_c('p',[_vm._v("E-post: support@memlist.se")])])
}
var staticRenderFns = []

export { render, staticRenderFns }